<template>
  <Button
    @click="toggleUserMenu"
    aria-haspopup="true"
    aria-controls="user-menu"
    icon="pi pi-angle-down"
    iconPos="right"
    severity="secondary"
    :label="buttonLabel"
    :aria-label="ariaLabel || buttonLabel"
    text
    type="button"
    v-bind="$attrs"
  />

  <Menu ref="userMenu" id="user-menu" :model="userMenuItems" :popup="true" class="w-auto">
    <template #item="{ label, item, props }">
      <!-- Route-based items -->
      <router-link v-if="item.route" v-slot="{ href, navigate }" :to="item.route" custom>
        <a :href="href" v-bind="props.action" @click="navigate">
          <span v-bind="props.icon" />
          <span v-bind="props.label">{{ label }}</span>
        </a>
      </router-link>

      <!-- Non-route items (future-safe) -->
      <a v-else href="javascript:void(0)" v-bind="props.action">
        <span v-bind="props.icon" />
        <span v-bind="props.label">{{ label }}</span>
      </a>
    </template>
  </Menu>
</template>

<script setup lang="ts">
import { computed, onBeforeMount, ref } from "vue";
import { RouterLink } from "vue-router";
import type { MenuItem } from "@/models";
import { mockAuth } from "@/core/store/mock/mock.auth";
import { auth as prodAuth } from "@/core/store/auth";
import { useAppContextStore } from "@/core/store";
import { useEnvironmentFlags } from "@/core/composables/useEnvironmentFlags";

interface Props {
  ariaLabel?: string;
}

defineProps<Props>();

const contextStore = useAppContextStore();
if (!contextStore) {
  throw new Error("UserNavMenu: contextStore injection missing");
}

const context = computed(() => contextStore.context);
const { isProdEnvironment } = useEnvironmentFlags();

// Decide which stores to use (prod vs mock)
const auth = computed(() => (isProdEnvironment.value ? prodAuth : mockAuth));

const buttonLabel = computed<string>(() => auth.value.account?.name ?? "User");

const userMenuItems = ref<MenuItem[]>([]);

onBeforeMount(() => {
  userMenuItems.value = [
    {
      label: "Resume Profile",
      icon: "pi pi-fw pi-file-word",
      route: `/resumes/${context.value.user.resumeId}`,
    },
    {
      label: "Sign-Out",
      icon: "pi pi-fw pi-sign-out",
      route: "",
      class: "p-disabled hidden",
    },
  ];
});

// PrimeVue Menu ref + toggle
const userMenu = ref();

const toggleUserMenu = (event: Event) => {
  (userMenu.value as any)?.toggle(event);
};
</script>

<style scoped>
/* keep empty / scoped for future tweaks */
</style>
